import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { auth } from "../firebase/firebaseConfig";
import { signOut } from "firebase/auth";
import { hasAccountAccess } from "../utils/subscriptionAccess";

const BlockedListingRoute = ({ status }) => {
    useEffect(() => {
        signOut(auth);
    }, []);
    return <Navigate to={`/shop-login?status=${status || "review"}`} replace />;
};

const RestrictedRoute = ({ allowedTypes = [] }) => {
    const { currentUser, userLoading } = useAuth();

    if (userLoading) {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
                <div className="animate-spin h-14 w-14 border-4 border-black border-t-transparent rounded-full"></div>
            </div>
        );
    }

    if (!currentUser) {
        return <Navigate to="/shop-login" replace />;
    }

    if (!allowedTypes.includes(currentUser.type)) {
        return <Navigate to="/shop-login" replace />;
    }

    const isBusiness = ["printShop", "supplier", "specialist"].includes(currentUser.type);
    const listingIsNotApproved = isBusiness && currentUser.status !== "approved";

    if (listingIsNotApproved) {
        return <BlockedListingRoute status={currentUser.status} />;
    }

    if (isBusiness && !hasAccountAccess(currentUser)) return <Navigate to="/shop-login?subscription=required" replace />;
    return <Outlet />;
};

export default RestrictedRoute;
